var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 505.011 505.011",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2d308b"
    },
    d: "M431.05,431.055c-98.6,98.6-258.5,98.6-357.1,0s-98.6-258.5,0-357.1s258.5-98.6,357.1,0 c77.9,77.9,94.2,193.9,49.2,287.8c-9.6,20.1-22.1,39.2-37.4,56.7C439.15,422.755,435.15,426.955,431.05,431.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M483.05,130.955l-79.6,79.6c-11.9,11.9-31.3,11.9-43.2,0l-17.7-17.6c-11.9-11.9-11.9-31.3,0-43.2 c7.3-7.3,7.3-19.2,0-26.5l-26.6-26.6c-7.3-7.3-19.2-7.3-26.5,0l-29.1,29.1l-8.4-8.4l29.1-29.1c11.9-11.9,31.3-11.9,43.2,0l26.6,26.6 c11.9,11.9,11.9,31.3,0,43.2c-7.3,7.3-7.3,19.2,0,26.5l17.6,17.6c7.3,7.3,19.2,7.3,26.5,0l82.1-82.1 C479.25,123.655,481.25,127.255,483.05,130.955z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000000"
    },
    points: "259.55,145.455 232.35,118.155 254.15,105.455 272.25,123.655 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000"
    },
    d: "M434.95,310.755l-240.6-240.7c-6.8-6.8-17.9-6.8-24.7,0l-127.2,127.3c-6.8,6.8-6.8,17.9,0,24.7 l240.7,240.7c6.8,6.8,17.9,6.8,24.7,0l127.2-127.2C441.85,328.655,441.85,317.555,434.95,310.755z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 160.052,
    y: 111.408,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 252.0434 355.5158)",
    style: {
      fill: "#3d78b3"
    },
    width: 79.199,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.466,
    y: 165.37,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 306.0103 485.7925)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.456,
    y: 201.371,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 341.9925 572.6992)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.456,
    y: 237.372,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 377.9916 659.6129)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.446,
    y: 273.373,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 413.9737 746.5196)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.446,
    y: 309.374,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 449.9728 833.4333)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.504,
    y: 127.338,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 152.0142 345.9419)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.494,
    y: 163.339,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 187.9963 432.8486)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.565,
    y: 199.27,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 224.1662 519.6916)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.555,
    y: 235.271,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 260.1483 606.5982)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.555,
    y: 271.272,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 296.1474 693.512)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.545,
    y: 307.273,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 332.1295 780.4186)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.545,
    y: 343.274,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 368.1286 867.3324)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.603,
    y: 161.246,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 70.1644 379.8546)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.603,
    y: 197.249,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 106.1621 466.7717)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.593,
    y: 233.25,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 142.1442 553.6784)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.663,
    y: 269.181,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 178.3141 640.5214)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.168,
    y: 323.142,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 232.2639 770.791)",
    style: {
      fill: "#3d78b3"
    },
    width: 79.199,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.654,
    y: 377.184,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 286.2944 901.2556)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.701,
    y: 195.152,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -11.6841 413.7639)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.307,
    y: 285.12,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 78.2614 630.9557)",
    style: {
      fill: "#3d78b3"
    },
    width: 180.998,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.752,
    y: 375.083,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 168.4511 848.2408)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.752,
    y: 411.084,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 204.4503 935.1545)",
    style: {
      fill: "#3d78b3"
    },
    width: 28.3,
    height: 28.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.082ab47010c5db5ece81f5be110f0091.svg";
export { ForwardRef as ReactComponent };